export default "__VITE_ASSET__DNHFz69N__"